import env from 'enviro';
import { FTS_STAGED_USERS, M1_HUB_PAGES, M2_BUNDLE_PAGES, M3_SMART_CRM_PAGES, HUBSPOT_CREDITS_PAGE_V2, SLASHING_PRICES } from '../constants/Gates';
import { SEATS_VERSIONS_FEATURE_FLAG, SLASHING_PRICES_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { hasAnyMarketingPlusSkuInProductData } from './productsUtils';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return gates === null || gates === void 0 ? void 0 : gates.includes(gateKey);
};
export const getIsUngatedForSeats = state => {
  const isUngatedByPublicFlagOrOverride = getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  });
  const urlParams = new URLSearchParams(window.location.search);
  const isUngatedByQueryParamOverride = urlParams.get('forceSeatsPricing') === 'true';
  const isUngatedOnPublic = isUngatedByPublicFlagOrOverride || isUngatedByQueryParamOverride;
  return isUngatedOnPublic || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getAreGatesPopulated = state => {
  return state.gates.length > 0;
};
export const getIsUngatedForMarketingPlus = state => {
  return hasAnyMarketingPlusSkuInProductData(state);
};
export const getIsUngatedForFTSStagedUsers = state => getIsUngated(state, {
  gateKey: FTS_STAGED_USERS
});
export const getIsUngatedForM1HubPages = state => getIsUngated(state, {
  gateKey: M1_HUB_PAGES
});
export const getIsUngatedForM2BundlePages = state => getIsUngated(state, {
  gateKey: M2_BUNDLE_PAGES
});
export const getIsUngatedForM3SmartCrmPages = state => getIsUngated(state, {
  gateKey: M3_SMART_CRM_PAGES
});
export const getIsUngatedForHubSpotCreditsPageV2 = state => getIsUngated(state, {
  gateKey: HUBSPOT_CREDITS_PAGE_V2
});
export const getIsUngatedForSlashingPrices = state => {
  return getIsUngated(state, {
    gateKey: SLASHING_PRICES_FLAG
  }) || getIsUngated(state, {
    gateKey: SLASHING_PRICES
  });
};